import { FieldTypeType } from "../../../services/helpers/types";

export const getFieldClassName = (
  fieldType?: FieldTypeType,
  isTabletView?: boolean,
  hasNoteOption?: boolean
) => {
  switch (fieldType) {
    case FieldTypeType.StaticText:
    case FieldTypeType.Button:
    case FieldTypeType.TextArea:
      return `dui-field-title-top dui-field-${fieldType}`;

    case FieldTypeType.Urine:
      const noteOptionClass = hasNoteOption
        ? "dui-field-urine-note-option"
        : "";
      return `dui-field-title-left dui-field-${fieldType} ${noteOptionClass}`;
    default:
      if (isTabletView) {
        return "dui-field-title-top";
      } else {
        return "dui-field-title-left";
      }
  }
};
